import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";

export default class extends Controller {
  static values = {
    cssMode: { type: Boolean, default: true },
    loop: { type: Boolean, default: false },
    slidesPerGroup: { type: Number, default: 1 },
    desktopSpaceBetween: { type: Number, default: 16 },
  }

  connect() {
    new Swiper(this.element, {
      spaceBetween: 16,
      slidesPerView: "auto",
      centeredSlides: false,
      centeredSlidesBounds: this.cssModeValue,
      cssMode: this.cssModeValue,
      loop: this.loopValue,
      mousewheel: false,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: "auto",
          slidesPerGroup: this.slidesPerGroupValue,
          spaceBetween: this.desktopSpaceBetweenValue,
        },
      },
    });
  }
}
